import { useState, useEffect } from 'react'
import { getAuctionUser } from '../redux/selectors'
import { useSelector } from 'react-redux'

// import { history } from 'services/history.js'
import { listUpcomingAuctions } from '../api'
import { getAuctionStatus } from '../util/dateString'

import css from './sass/mypages.module.scss'
import themeCss from '../components/sass/theme.module.scss'
import AuctionCardUpcoming from './AuctionCardUpcoming'
import AuctionRowPast from './AuctionRowPast'

export default function MyAuctions() {

  const [myAuctions, setMyAuctions] = useState()
  const [myPastAuctions, setMyPastAuctions] = useState([])
  const [myUpcomingAuctions, setMyUpcomingAuctions] = useState([])
  const [myLiveAuctions, setMyLiveAuctions] = useState([])
  const [noAuctions, setNoAuctions] = useState(false)

  // if user isn't registered for any auctions, show list of currrent public auctions
  // (failsafe against users finding their way to the app w/o coming in through a specific auction)
  const [nonRegisteredAuctionList, setNonRegisteredAuctionList] = useState([])
  const [lookupCurrentAuctions, setLookupCurrentAuctions] = useState(false)
  useEffect(() => {
    if (lookupCurrentAuctions) {
      const getCurrentAuctions = async () => {
        try {
          const currentAuctions = (await listUpcomingAuctions())
                                         .map(auction => {
                                            auction.status = getAuctionStatus(auction.StartTime, auction.EndTime)
                                            return auction
                                          })
                                         // auction.IsInviteeOnly doesn't exist yet, but will be used if we ever get an invitee only auction
                                         .filter(auction => auction.status !== "ended" && !auction.IsInviteeOnly)

          console.log({currentAuctions})
          setNonRegisteredAuctionList(currentAuctions)
        }
        catch (e) {
          console.log('error', e)
        }
      }
      getCurrentAuctions()
    }
  }, [lookupCurrentAuctions])

  const auctionUser = useSelector(getAuctionUser)

  useEffect(() => {
    if (auctionUser) {
      setMyAuctions(auctionUser.MyAuctions.map((auction) => auction.Auction))
    }
  }, [auctionUser])

  useEffect(() => {
    if (!myAuctions)
      return

    const today = new Date()

    const past = []
    const upcoming = []
    const live = []

    myAuctions.forEach((auction) => {
      const isLive = auction.StartTime < today.toISOString()

      //if auction is public
      if (auction.Status === 'PUBLIC') {
        if (today.toISOString() > auction.EndTime) {
          past.push(auction)
        } else {
          //if auction is not ended
          if (isLive) live.push(auction)
          else upcoming.push(auction)
        }
      }
    })

    setMyPastAuctions(past)
    setMyUpcomingAuctions(upcoming)
    setMyLiveAuctions(live)

    if (past.length === 0 && upcoming.length === 0 && live.length === 0) setNoAuctions(true)
    else setNoAuctions(false)

    if (upcoming.length === 0 && live.length === 0) setLookupCurrentAuctions(true)

  }, [myAuctions])

  if (!auctionUser) return <></>
  
  return (
    <>
{/*      <div className={css['mypages-header']}>
        <h2 className={css['mypages-headings']}>My Auctions</h2>
      </div>
*/}      <div className={themeCss['blue-background']}>

        {nonRegisteredAuctionList.length !== 0 &&
          <>
            <h3 className={css['mypages-headings-white']}>Current Auctions</h3>
            {nonRegisteredAuctionList.map((auction) => {
              return (<AuctionCardUpcoming key={auction.AuctionId} auction={auction} isLive={auction.status === 'started'}/>)
            })}
          </>
        }

        {myLiveAuctions.length !== 0 && myLiveAuctions.map((auction) => {
          return (<AuctionCardUpcoming key={auction.AuctionId} auction={auction} isLive={true}/>)
        })}

        {myUpcomingAuctions.length !== 0 && <>
            <h3 className={css['mypages-headings-white']}>Upcoming Auctions</h3>
            {myUpcomingAuctions.map((auction) => {
              return (<AuctionCardUpcoming key={auction.AuctionId} auction={auction} />)
            })}
          </>
        }

        {myPastAuctions.length !== 0 && <>
            <h3 className={css['mypages-headings-white']}>My Past Auctions</h3>
            <div className={css['mypages-card']}>
              {myPastAuctions.map((auction) => {
                return (<AuctionRowPast key={auction.AuctionId} auction={auction} />)
              })}
            </div>
          </>
        }

        {noAuctions && nonRegisteredAuctionList.length === 0 && <div className={css['mypages-card']}>
            <p>
              You are not currently signed up for any auctions. If you believe this in incorrect, please contact the auction administrator.
            </p>
          </div>
        }
      </div>
    
    </>
  )
}